import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input, Select, Row, Col, Form, DatePicker, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { CheckCircleFilled, EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import NoRecordFound from '../../components/common/NoRecordFound';

function Donor() {
  const { t } = useTranslation(['common']);
  const [form] = Form.useForm();
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  const user = JSON.parse(localStorage.getItem('user'));
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState();
  const [reportObj, setReportObj] = useState(user.userType === 'A' ? { limit: 1000, offset: 0, organizationId: null, startDate: null, endDate: null } : { limit: 1000, offset: 0, organizationId: user.organizationId, startDate: null, endDate: null });
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  const u = useFetchUsers();
  console.log(u);
  const userCount = u.response ? u.response.data.length : 0;
  console.log(userCount);
  let orgObj;
  const orgResp = useFetchOrganizations();
  orgObj = orgResp.response ? orgResp.response.data : [];
  const token = getTokenfromUserObj();

  useEffect(() => {
    const userList = async () => {
      console.log('user list function called');
      // const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      // const limit = 1000;
      // const offset = 0;
      // let orgId = null;
      // let startDate = null;
      // let endDate = null;
      // let serverObj = {
      //   limit: 1000,
      //   offset: 0,
      //   organizationId: null,
      //   startDate: null,
      //   endDate: null,
      // };
      let fetchDonorQuery;
      if (user.userType === 'A') fetchDonorQuery = `${app.URL}/user/getalldonors`;
      // else if (user.userType === 'O') fetchDonorQuery = `${app.URL}/user/getdonorsbyorg/${user.organizationId}`;
      else if (user.userType === 'O') fetchDonorQuery = `${app.URL}/user/getalldonors`;
      if (reportObj.startDate > reportObj.endDate) return;
      const donorResp = await axios.post(fetchDonorQuery, reportObj, { headers: { auth: token } });
      console.log('🚀 ~ file: Users.js:31 ~ userList ~ userResp', donorResp.data);
      donorResp.data ? setFetchUsers(donorResp.data.data) : ' ';
      donorResp.data ? setPagesCount(donorResp.data.data.length) : ' ';
      donorResp.data ? setRenderList(donorResp.data.data.slice(0, 50)) : ' ';
    };
    userList();
  }, [reportObj]);
  const handleSearch = async () => {
    console.log('calling');
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      console.log(result);
      searchedUser = result.data.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const onSearch = async (value) => {
    console.log(value);
    try {
      let searchAPI;
      if (user.userType === 'A') searchAPI = `${app.URL}/user/searchdonors/${value}`;
      if (user.userType === 'O') searchAPI = `${app.URL}/user/searchdonorsbyorg/${user.organizationId}/${value}`;
      console.log(searchAPI);
      const result = await axios.get(searchAPI);
      console.log(result);
      searchedUser = result.data.data;
      setRenderList(searchedUser);
      setPagesCount(searchedUser.length);
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
    // if(users){
    //   console.log("users")
    //   setRenderList(users)
    // }
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchUsers.slice(0, 50));
      //  console.log(organizations.length)
      setPagesCount(fetchUsers.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editUser = (e) => {
    console.log(e);
    localStorage.setItem('donorId', JSON.stringify(e.donorId));
    if (user.userType === 'A') navigate('/donor/donationhistory', { replace: true });
    if (user.userType === 'O') navigate('/orgdonor/donationhistory', { replace: true });
  };
  const gotoRecurring = (e) => {
    console.log(e);
    localStorage.setItem('donorIdforRecurring', e.donorId);

    if (user.userType === 'O') navigate('/recurring/bydonerorg', { replace: true });
    else if (user.userType === 'A') navigate('/recurring/bydoner', { replace: true });
  };

  console.log(reportObj);
  const onFinish = (values) => {
    console.log('Success:', values);
    let newStartDate, newEndDate;
    if (values.startDate) {
      newStartDate = values.startDate ? values.startDate._d.toUTCString() : null;
      newStartDate = newStartDate ? new Date(newStartDate).toISOString().slice(0, 19).replace('T', ' ') : null;
    }
    if (values.endDate) {
      newEndDate = values.endDate ? values.endDate._d.toUTCString() : null;
      newEndDate = newEndDate ? new Date(newEndDate).toISOString().slice(0, 19).replace('T', ' ') : null;
    }
    user.userType === 'A'
      ? setReportObj({
          organizationId: values.organizationId ? values.organizationId : null,
          startDate: values.startDate ? newStartDate.slice(0, 50) + ' 00:00:00' : null,
          endDate: values.endDate ? newEndDate.slice(0, 50) + ' 23:59:59' : null,
          limit: 1000,
          offset: 0,
        })
      : setReportObj({
          organizationId: user.organizationId ? user.organizationId : null,
          startDate: values.startDate ? newStartDate.slice(0, 50) + ' 00:00:00' : null,
          endDate: values.endDate ? newEndDate.slice(0, 50) + ' 23:59:59' : null,
          limit: 1000,
          offset: 0,
        });
    if (newStartDate > newEndDate) message.error('Start date must be less than or equal to end date');
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleClearClick = () => {
    form.resetFields();
    user.userType === 'A' ? setReportObj({ limit: 1000, offset: 0, organizationId: null, startDate: null, endDate: null }) : setReportObj({ limit: 1000, offset: 0, organizationId: user.organizationId, startDate: null, endDate: null });
  };

  console.log(renderList);

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-2 mt-3 '>
        <div className='col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Donors Report')}</div>
        <Form
          name='basic'
          form={form}
          className='ml-5'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 8,
          }}
          style={{ alignItems: 'flexEnd' }}
          // style={{
          //   maxWidth: 600,
          // }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          {user.userType === 'A' ? (
            <div className='row p-0 mt-2'>
              <div className='col-lg-2 mr-11'>
                <Form.Item
                  style={{ width: '870px' }}
                  colon={false}
                  // label='Organization'
                  name='organizationId'
                  rules={[
                    {
                      required: false,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      width: 200,
                    }}
                    placeholder='Select Organization'
                  >
                    {orgObj.map((orgs) => {
                      return (
                        <Option key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              {/* <div className='col-lg-3'>
              <Search
               className='donor-search'
                placeholder='Search by Name/ Email'
                onChange={handleSearchChange}
                onSearch={onSearch}
                style={{
                  width: 300,
                }}
              />
            </div> */}
              <div className='col-lg-2'>
                <Form.Item
                  colon={false}
                  style={{
                    width: 550,
                  }}
                  name='startDate'
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date From' />
                </Form.Item>
              </div>
              <div className='col-lg-2'>
                <Form.Item
                  colon={false}
                  style={{
                    width: 550,
                  }}
                  name='endDate'
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date To' />
                </Form.Item>
              </div>
              <div className='col-lg-1'>
                <button className='btn btn-primary button' onClick={handleClearClick}>
                  Clear
                </button>
              </div>
              <div className='col-lg-1'>
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Search
                </button>
              </div>
            </div>
          ) : (
            ''
          )}
          {user.userType === 'O' ? (
            <div className='row p-0 mt-2'>
              <div className='col-lg-3'>
                <Search
                  className='donor-search'
                  placeholder='Search by Name / Email'
                  onChange={handleSearchChange}
                  onSearch={onSearch}
                  style={{
                    width: 300,
                  }}
                />
              </div>
              <div className='col-lg-2'>
                <Form.Item
                  colon={false}
                  style={{
                    width: 550,
                  }}
                  name='startDate'
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date From' />
                </Form.Item>
              </div>
              <div className='col-lg-2'>
                <Form.Item
                  colon={false}
                  style={{
                    width: 550,
                  }}
                  name='endDate'
                  rules={[
                    {
                      required: false,
                      message: 'Please select date!',
                    },
                  ]}
                >
                  <DatePicker placeholder='Date To' />
                </Form.Item>
              </div>

              <div className='col-lg-1'>
                <button className='btn btn-primary button' onClick={handleClearClick}>
                  Clear
                </button>
              </div>
              <div className='col-lg-1'>
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Search
                </button>
              </div>
            </div>
          ) : (
            ''
          )}
        </Form>
        <div className='col-lg-11 col-md-12 col-sm-12 '>
          <div class=' styled-table '>
            <table class='table text-black'>
              <thead class='thead-light'>
                <tr>
                  {/* <th>{t("ID")}</th> */}
                  <th>{t('Donor Name')}</th>
                  <th>{t('Email')}</th>
                  <th>{t('Mobile')}</th>
                  <th>{t('Total Donation')}</th>
                  <th>{t('Service Fee')}</th>
                  <th>{t('Recurring')}</th>
                  <th>{t('Status')}</th>
                  {/* <th> </th> */}
                </tr>
              </thead>
              <tbody>
                {renderList
                  ? renderList.map((output) => (
                      <tr className='row-hover'>
                        <td
                          style={{ width: '300px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          {output.firstName ? output.firstName : ' '} {output.lastName ? output.lastName : ' '}
                        </td>
                        <td
                          style={{ width: '300px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          {output.email}
                        </td>
                        <td
                          style={{ width: '250px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          {output.phone ? `(${output.phone.slice(2, 5)}) ${output.phone.slice(5, 8)}-${output.phone.slice(8, output?.phone?.length)}` : ' '}
                        </td>
                        <td
                          style={{ width: '200px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          $ {output.totalAmount ? output.totalAmount : '0'}
                        </td>
                        <td
                          style={{ width: '200px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          ${output.totalServiceAmount?Number(output.totalServiceAmount)<=0.09&&Number(output.totalServiceAmount)>0 ? (output.totalServiceAmount).toFixed(4) : (output.totalServiceAmount).toFixed(2):'0.00'}
                          {/* ?Number(output.totalServiceAmount)<=0.09&&Number(output.totalServiceAmount)>0 ? (output.totalServiceAmount).toFixed(4) : (output.totalServiceAmount).toFixed(2):'0.00' */}
                        </td>
                      <td style={{ width: '80px', textAlign: 'center' }}>{output.recurring === 1 ? <CheckCircleFilled onClick={() => gotoRecurring(output)} style={{ color: '#0a466b', fontSize: '20px' }} /> : <p style={{ paddingLeft: '10px', color: 'black' }}>-</p>}</td>
                        <td
                          style={{ width: '160px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        >
                          {output.isActive === 1 ? 'Active' : 'Inactive'}
                        </td>
                        {/* <td style={{width:"160px"}}>{output.recurring===1?<button className='btn button btn-primary recurr-btn ' onClick={()=>gotoRecurring(output)}>view Recurr.</button>:" "}</td> */}
                        {/* <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editUser(output)}} /> */}
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                        {/* </td> */}
                      </tr>
                    ))
                  : ' '}
              </tbody>
            </table>
            {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
          </div>
        </div>
        <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
      </div>
    </div>
    //   </div>
    // </div>
  );
}

export default Donor;
